var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class ActorIntersect {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    isIntersectingWithActor(actor) {
        return this.isIntersectingWithActorOnX(actor) && this.isIntersectingWithActorOnY(actor);
    }
    overlapWithActorOnX(actor) {
        if (!this.actor.actorMounted.outermostRenderedAspect || !actor.actorMounted.outermostRenderedAspect)
            return 0;
        const m1 = this.actor.actorMounted.outermostRenderedAspect.aspectMount.measureDom.measuredBoundingClientRect;
        const m2 = actor.actorMounted.outermostRenderedAspect.aspectMount.measureDom.measuredBoundingClientRect;
        const smallestRight = Math.min(m1.left + m1.width, m2.left + m2.width);
        const largestLeft = Math.max(m1.left, m2.left);
        // console.log(smallestRight - largestLeft, m1, m2);
        if (smallestRight <= largestLeft)
            return 0;
        return smallestRight - largestLeft;
    }
    isIntersectingWithActorOnX(actor) {
        return this.overlapWithActorOnX(actor) > 0;
    }
    overlapWithActorOnY(actor) {
        if (!this.actor.actorMounted.outermostRenderedAspect || !actor.actorMounted.outermostRenderedAspect)
            return 0;
        const m1 = this.actor.actorMounted.outermostRenderedAspect.aspectMount.measureDom.measuredBoundingClientRect;
        const m2 = actor.actorMounted.outermostRenderedAspect.aspectMount.measureDom.measuredBoundingClientRect;
        const smallestBottom = Math.min(m1.top + m1.height, m2.top + m2.height);
        const largestTop = Math.max(m1.top, m2.top);
        if (smallestBottom <= largestTop)
            return 0;
        return smallestBottom - largestTop;
    }
    isIntersectingWithActorOnY(actor) {
        return this.overlapWithActorOnY(actor) > 0;
    }
    overlapAreaWithActor(actor) {
        return this.overlapWithActorOnX(actor) * this.overlapWithActorOnY(actor);
    }
    get intersectingActors() {
        return this.actor.context.stage.stageMountedActors.mountedActors.filter(actor => actor !== this.actor && this.isIntersectingWithActor(actor));
    }
    intersectingActorsOfType(type) {
        return this.actor.context.stage.stageMountedActors.mountedActors.filter(actor => actor.type === type && actor !== this.actor && this.isIntersectingWithActor(actor));
    }
    mainIntersectingActorsOfType(type) {
        const all = this.intersectingActorsOfType(type);
        if (all.length === 0)
            return null;
        let bestActor = all[0];
        let bestArea = 0;
        all.forEach(actor => {
            const area = this.overlapAreaWithActor(actor);
            if (area > bestArea) {
                bestActor = actor;
                bestArea = area;
            }
        });
        return bestActor;
    }
}
__decorate([
    computed
], ActorIntersect.prototype, "intersectingActors", null);
